import { Injectable } from "@angular/core";
import { ApiServiceService } from "../../../services/api-service.service";
import { environment } from "../../../../environments/environment";
import { catchError, throwError } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class WalletPointsTransactionService {


    constructor(private apiService: ApiServiceService) { }

    EmployeePointsHistory(employee_id: any) {
        return this.apiService.post(`${environment.apiUrl}/employee-points-history?employee_id=${employee_id}`)
            .pipe(catchError(this.handleError));
    }

    GetEmployeePointsHistoryByMonth(data: any) {
        return this.apiService.post(`${environment.apiUrl}/employee-points-history/get-history-by-month`, data)
            .pipe(catchError(this.handleError));
    }

    CompanyPointsHistory(company_id: any) {
        return this.apiService.get(`${environment.apiUrl}/company-profile/transactions?company_id=${company_id}`)
            .pipe(catchError(this.handleError));
    }

    GetCompanyPointsHistoryByMonth(company_id: any, year_and_month: any) {
        return this.apiService.get(`${environment.apiUrl}/company-profile/transactions-months-list/?company_id=${company_id}&year_and_month=${year_and_month}`)
            .pipe(catchError(this.handleError));
    }

    VendorPointsHistory(vendor_id: any) {
        return this.apiService.get(`${environment.apiUrl}/vendors/vendor-transactions/?vendor_id=${vendor_id}`)
            .pipe(catchError(this.handleError));
    }

    GetVendorPointsHistoryByMonth(vendor_id: any, year_and_month: any) {
        return this.apiService.get(`${environment.apiUrl}/vendors/transactions-months-list/?vendor_id=${vendor_id}&year_and_month=${year_and_month}`)
            .pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }

}